<template>
  <div class="a-container-form u-margin-top-24 messages-subscriptions__price">
    <div class="a-input-group ">
      <p>{{$t('form.messages.settings.from')}}:</p>
      <input-cost class="a-input a-input--w-166" v-model="from" @blur="onCostChanged"></input-cost>
    </div>
    <div class="a-input-group " :class="{ 'a-input-group--error': $v.to.$dirty && !$v.to.greaterThanFrom}">
      <p>{{$t('form.messages.settings.to')}}:</p>
      <input-cost class="a-input a-input--w-166" v-model="to" @blur="onCostChanged"></input-cost>
    </div>
  </div>
</template>

<script>
  import InputCost from '@/widgets/input-cost'
  import { required } from '@/validators'

  export default {
    components: {
      InputCost
    },

    computed: {
      from: {
        get() {
          return this.cost.from || this.$store.getters.costSettings.from;
        },

        set(value) {
          this.cost.from = value;
        }
      },

      to: {
        get() {
          return this.cost.to || this.$store.getters.costSettings.to;
        },

        set(value) {
          this.cost.to = value;
        }
      }
    },

    data: () => ({
      cost: {
        from: undefined,
        to: undefined
      }
    }),

    validations: {
      to: {
        greaterThanFrom() {
          return this.to === undefined || this.to > this.from;
        }
      }
    },

    methods: {
      async onCostChanged() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }



        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('updateCostSetting', {
              from: this.cost.from,
              to: this.cost.to
            });
            this.cost.from = undefined;
            this.cost.to = undefined;
          }
          catch(e) {
            console.error('unable to update cost settings', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
